import React, { type PropsWithChildren } from 'react'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

interface Props {
  planType: 'basic' | 'premium' | 'edu'
  description: React.ReactNode | string
  pricing: React.ReactNode
  className?: string
}

const PlanCard: React.FC<PropsWithChildren<Props>> = ({
  planType,
  description,
  pricing,
  className,
  children,
}) => {
  const { t } = useTranslation()
  return (
    <section
      aria-labelledby={`${planType}-plan-heading`}
      className={classNames(
        'flex w-full flex-col rounded-lg border bg-white px-5 max-w-[360px] dark:bg-black-bg2',
        className
      )}>
      <h2 id={`${planType}-plan-heading`} className="mb-3 font-semibold text-h3">
        {t(`plans.${planType}.title`)}
      </h2>
      <div className="flex flex-col h-[165px]">
        <p className="leading-[17px]">{description}</p>
        <div className="flex flex-1 flex-col justify-center">{pricing}</div>
      </div>
      {children}
    </section>
  )
}

export default PlanCard
